import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button as MuiButton } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Button.scss';

const sizes = ['medium', 'small', 'large'];
const types = ['common', 'filled'];

function Button(props) {
  const {
    label,
    size,
    onClick,
    history,
    href,
    Icon,
    className,
    variant,
    httpLink,
    ...restProps
  } = props;

  const handleClick = e => {
    if (httpLink) {
      return;
    }

    if (href) {
      history.push(href);
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  return httpLink ? (
    <a href={href} className={styles.link}>
      <MuiButton
        {...restProps}
        onClick={handleClick}
        className={classnames(styles.button, className, styles[variant])}
      >
        <div className={styles.labelWrapper}>
          {Icon && <Icon className={styles.icon} />}
          <div className={styles.label}>{label}</div>
        </div>
      </MuiButton>
    </a>
  ) : (
    <MuiButton
      {...restProps}
      onClick={handleClick}
      className={classnames(styles.button, className, styles[variant])}
    >
      <div className={styles.labelWrapper}>
        {Icon && <Icon className={styles.icon} />}
        <div className={styles.label}>{label}</div>
      </div>
    </MuiButton>
  );
}

Button.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOf(sizes),
  variant: PropTypes.oneOf(types),
};

Button.defaultProps = {
  label: '',
  size: sizes[0],
  variant: types[0],
};

export default withRouter(Button);



// WEBPACK FOOTER //
// ./src/components/controls/Button.jsx